/**
	* Map marker class
	* Handles: map markers
	* @module mapmarker
*/

// OpenLayers
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Icon from "ol/style/Icon";
import Style from "ol/style/Style";

import Vector2 from "lib/classes/vector2";

export default class MapMarker {
	public source:VectorSource;
	public layer:VectorLayer<VectorSource>;
	public feature:Feature<Geometry>;
	public mousePosition:Vector2;
	public pixel:Vector2;
	
	constructor(icon:Icon) {
		this.source = new VectorSource();
		this.layer = new VectorLayer({
			source: this.source,
			zIndex: 100
		});
		this.feature = new Feature<Geometry>({
			geometry: new Point([0,0])
		});
		this.feature.setStyle(new Style({
			image: icon
		}));
		
		this.feature.set("map-marker", true);
		
		this.source.addFeature(this.feature);
	}
	public setMousePosition(x:number, y:number) {
		this.mousePosition = new Vector2(x, y);
	}
	public setPixel(x:number, y:number) {
		this.pixel = new Vector2(x, y);
	}
}